const RecordQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 60
    },
    {
        name: 'Container No',
        code: 'containerNo',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        listFilter: true,
        width: 150
    },
    {
        name: 'Scan Code',
        code: 'scanCode',
        column: true,
        sortable: true,
        defaultFilter: true,
        listFilter: true,
        align: 'center',
        width: 200
    },
    {
        name: 'Operator',
        code: 'operator',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Scan Time',
        code: 'scanTime',
        column: true,
        defaultFilter: false,
        listFilter: false,
        sortable: true,
        align: 'center',
        width: 200
    },
    {
        name: 'scanResult',
        code: 'result',
        column: true,
        sortable: true,
        align: 'left',
        width: 200
    },
    {
        name: 'message',
        code: 'message',
        column: true,
        sortable: true,
        align: 'left'
    }
];
export default RecordQueryFields;
